import { MAIN_SITE_URL } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20composition%20of%20colorful%20streetwear%20clothing%20items%20scattered%20on%20raw%20concrete%20floor%2C%20vibrant%20neon%20graphic%20tees%2C%20ripped%20denim%20jeans%2C%20retro%20sneakers%2C%20skateboard%20deck%2C%20spray%20paint%20cans%2C%20natural%20window%20light%20casting%20angular%20shadows%2C%20edgy%20urban%20editorial%20style%2C%20authentic%20street%20fashion%20photography&width=1600&height=700&seq=cta-2026-v3&orientation=landscape"
        alt="Start exploring the most complete CSSBuy spreadsheet system for agent shopping"
        title="CSSBuy Spreadsheet Agent Shopping Platform"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-xl">
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
            Ready to shop?
          </h2>
          <p className="text-white/75 text-sm md:text-base mb-8 md:mb-10 max-w-md leading-relaxed">
            Start exploring the most complete spreadsheet system for agent shopping. Browse thousands of curated items across all major platforms.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 bg-white text-foreground-950 px-6 py-3 rounded-full text-sm font-semibold hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              cssbuy sheet
              <span className="w-5 h-5 flex items-center justify-center bg-foreground-950 rounded-full">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </span>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-5 h-5 flex items-center justify-center bg-black/20 rounded-full">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}